import { hasModule, session } from './session'

/** Product navigation. Every item is gated by its capability, never a role list. */
export const NAV_ITEMS = [
  {
    label: 'Dashboard',
    route: '/',
    icon: 'lucide-house',
    section: 'main',
  },
  {
    label: 'Members',
    route: '/members',
    icon: 'lucide-users',
    permission: 'members.view',
    module: 'membership',
    section: 'main',
  },
  {
    label: 'Households',
    route: '/households',
    icon: 'lucide-house',
    permission: 'households.view',
    module: 'membership',
    section: 'main',
  },
  {
    label: 'Giving',
    route: '/giving',
    icon: 'lucide-hand-coins',
    permission: 'giving.view',
    module: 'giving',
    section: 'main',
  },
  {
    label: 'Pledges',
    route: '/pledges',
    icon: 'lucide-bookmark',
    permission: 'pledges.view',
    module: 'giving',
    section: 'main',
  },
  {
    label: 'Unassigned gifts',
    route: '/giving/unassigned',
    icon: 'lucide-inbox',
    permission: 'giving.view',
    module: 'giving',
    section: 'main',
  },
  {
    label: 'Funds',
    route: '/funds',
    icon: 'lucide-piggy-bank',
    permission: 'funds.view',
    module: 'giving',
    section: 'main',
  },
  {
    label: 'Campaigns',
    route: '/campaigns',
    icon: 'lucide-target',
    permission: 'funds.view',
    module: 'giving',
    section: 'main',
  },
  {
    label: 'Expenses',
    route: '/expenses',
    icon: 'lucide-wallet',
    permission: 'expenses.view',
    module: 'giving',
    section: 'main',
  },
  {
    label: 'Disbursements',
    route: '/disbursements',
    icon: 'lucide-arrow-up-right',
    permission: 'disbursements.view',
    module: 'giving',
    section: 'main',
  },
  {
    label: 'Fund transfers',
    route: '/fund-transfers',
    icon: 'lucide-arrow-right-left',
    permission: 'fund_transfers.view',
    module: 'giving',
    section: 'main',
  },
  {
    label: 'Expense summary',
    route: '/expenses/summary',
    icon: 'lucide-chart-pie',
    permission: 'expenses.view',
    module: 'giving',
    section: 'main',
  },
  {
    label: 'Welfare',
    route: '/welfare',
    icon: 'lucide-hand-heart',
    permission: 'welfare.view',
    module: 'giving',
    section: 'main',
  },
  {
    label: 'Sacraments',
    route: '/sacraments',
    icon: 'lucide-book-open',
    permission: 'sacraments.view',
    module: 'sacraments',
    section: 'main',
  },
  {
    label: 'Events',
    route: '/events',
    icon: 'lucide-calendar',
    permission: 'events.view',
    section: 'main',
  },
  {
    label: 'Messaging',
    route: '/messaging',
    icon: 'lucide-message-circle',
    permission: 'messaging.view',
    module: 'communications',
    section: 'main',
  },
  {
    label: 'Mass intentions',
    route: '/mass-intentions',
    icon: 'lucide-heart-handshake',
    permission: 'mass_intentions.view',
    module: 'liturgy',
    section: 'main',
  },
  {
    label: 'Mass calendar',
    route: '/mass-calendar',
    icon: 'lucide-calendar-days',
    permission: 'mass_intentions.view',
    module: 'liturgy',
    section: 'main',
  },
  {
    label: 'Today',
    route: '/today',
    icon: 'lucide-sun',
    permission: 'mass_intentions.sacristy',
    // Celebrant's day view; Finance Officer reads stipends from Mass intentions instead.
    module: 'liturgy',
    section: 'main',
  },
  {
    label: 'Mass schedules',
    route: '/mass-schedules',
    icon: 'lucide-clock',
    permission: 'mass_intentions.manage',
    module: 'liturgy',
    section: 'main',
  },
  {
    label: 'Gregorian series',
    route: '/gregorian-series',
    icon: 'lucide-repeat',
    permission: 'mass_intentions.manage',
    module: 'liturgy',
    section: 'main',
  },
  {
    label: 'Sacristy board',
    route: '/sacristy',
    icon: 'lucide-clipboard-list',
    permission: 'mass_intentions.sacristy',
    // Intention texts are pastoral; Finance Officer sees stipends under Mass intentions only.
    module: 'liturgy',
    section: 'main',
  },
  {
    label: 'Ministry',
    route: '/ministry',
    icon: 'lucide-users-round',
    permission: 'ministry.view',
    module: 'ministry',
    section: 'main',
  },
  {
    label: 'Safe environment',
    route: '/compliance',
    icon: 'lucide-shield-check',
    permission: 'compliance.view',
    module: 'safe_environment',
    section: 'main',
  },
  {
    label: 'Formation',
    route: '/formation',
    icon: 'lucide-graduation-cap',
    permission: 'formation.view',
    module: 'formation',
    section: 'main',
  },
  {
    label: 'Prayer requests',
    route: '/prayer-requests',
    icon: 'lucide-hand-heart',
    permission: 'prayer.view',
    module: 'portal',
    section: 'main',
  },
  {
    label: 'Facility bookings',
    route: '/facility-bookings',
    icon: 'lucide-building-2',
    permission: 'facilities.view',
    module: 'events',
    section: 'main',
  },
  {
    label: 'Reporting',
    route: '/reporting',
    icon: 'lucide-chart-column',
    permission: 'reporting.diocesan',
    section: 'main',
  },
  {
    label: 'Facilities & assets',
    route: '/facilities/assets',
    icon: 'lucide-building',
    permission: 'assets.view',
    module: 'assets',
    section: 'main',
  },
  {
    label: 'Inventory',
    route: '/inventory',
    icon: 'lucide-package',
    permission: 'inventory.view',
    module: 'inventory',
    section: 'main',
  },
  {
    label: 'Staff',
    route: '/staff',
    icon: 'lucide-briefcase',
    permission: 'hr.view',
    module: 'hr',
    section: 'main',
  },
  {
    label: 'Media',
    route: '/media',
    icon: 'lucide-folder-open',
    permission: 'media.view',
    section: 'main',
  },
  {
    label: 'Parish settings',
    route: '/settings',
    icon: 'lucide-settings',
    permission: 'settings.view',
    module: 'settings',
    section: 'admin',
  },
  {
    label: 'Giving statement',
    route: '/giving/statement',
    icon: 'lucide-file-spreadsheet',
    permission: 'giving.view',
    module: 'giving',
    section: 'main',
  },
  {
    label: 'Fund types',
    route: '/fund-types',
    icon: 'lucide-list-checks',
    permission: 'funds.view',
    module: 'giving',
    section: 'main',
  },
  {
    label: 'Support',
    route: '/support',
    icon: 'lucide-life-buoy',
    permission: 'support.view',
    section: 'admin',
  },
  {
    label: "What's new",
    route: '/whats-new',
    icon: 'lucide-sparkles',
    section: 'admin',
  },
  {
    label: 'Tenants',
    route: '/admin/tenants',
    icon: 'lucide-building-2',
    permission: 'platform.manage',
    // platform.manage alone is not enough: Church Access Manager carries it too
    section: 'admin',
  },
  {
    label: 'Public pages',
    route: '/site-pages',
    icon: 'lucide-globe',
    permission: 'settings.view',
    module: 'settings',
    section: 'admin',
  },
  {
    label: 'Templates',
    route: '/templates',
    icon: 'lucide-file-code',
    permission: 'messaging.view',
    module: 'settings',
    section: 'admin',
  },
  {
    label: 'Users & access',
    route: '/admin/users',
    icon: 'lucide-user-cog',
    permission: 'admin.users.view',
    section: 'admin',
  },
  {
    label: 'Permissions',
    route: '/settings/permissions',
    icon: 'lucide-shield-check',
    permission: 'permissions.manage',
    module: 'settings',
    section: 'admin',
  },
  {
    label: 'Profile requests',
    route: '/admin/profile-requests',
    icon: 'lucide-user-check',
    permission: 'members.approve_profile',
    module: 'membership',
    section: 'admin',
  },
  {
    label: 'Plan & usage',
    route: '/plan',
    icon: 'lucide-layers',
    permission: 'plan.view',
    section: 'admin',
  },
  {
    label: 'My hub',
    route: '/my',
    icon: 'lucide-user',
    permission: 'portal.access',
    section: 'member',
  },
  {
    label: 'Mass times',
    route: '/mass-schedule-public',
    icon: 'lucide-calendar-days',
    permission: 'portal.access',
    section: 'member',
  },
  {
    label: 'Request a Mass',
    route: '/mass-request',
    icon: 'lucide-church',
    permission: 'portal.access',
    section: 'member',
  },
  {
    label: 'My giving',
    route: '/my/giving',
    icon: 'lucide-heart',
    permission: 'portal.access',
    section: 'member',
  },
  {
    label: 'My pledges',
    route: '/my/pledges',
    icon: 'lucide-bookmark',
    permission: 'portal.access',
    section: 'member',
  },
  {
    label: 'My household',
    route: '/my/household',
    icon: 'lucide-house',
    permission: 'portal.access',
    section: 'member',
  },
  {
    label: 'My profile',
    route: '/my/profile',
    icon: 'lucide-pen-line',
    permission: 'portal.access',
    section: 'member',
  },
  {
    label: 'My events',
    route: '/my/events',
    icon: 'lucide-calendar-days',
    permission: 'portal.access',
    section: 'member',
  },
  {
    label: 'Prayer request',
    route: '/my/prayer',
    icon: 'lucide-heart-handshake',
    permission: 'portal.access',
    section: 'member',
  },
  {
    label: 'My certificates',
    route: '/my/certificates',
    icon: 'lucide-scroll-text',
    permission: 'portal.access',
    section: 'member',
  },
  {
    label: 'My formation',
    route: '/my/formation',
    icon: 'lucide-graduation-cap',
    permission: 'portal.access',
    section: 'member',
  },
  {
    label: 'My statement',
    route: '/my/statement',
    icon: 'lucide-file-text',
    permission: 'portal.access',
    section: 'member',
  },
]

/** True if boot grants the capability (or *). No role-list fallback. */
export function can(perm) {
  if (!perm) return !!session.boot?.authenticated
  if (!session.boot?.authenticated) return false
  const list = session.boot.permissions || []
  if (list.includes('*')) return true
  if (list.length) return list.includes(perm)
  return false
}

export function canAny(...perms) {
  return perms.some((p) => can(p))
}

function itemAllowed(item) {
  if (!session.boot?.authenticated) return false
  if (item.module && !hasModule(item.module)) return false
  if (item.permission) return can(item.permission)
  return true
}

export function canAccessRoute(meta = {}) {
  if (meta.public) return true
  if (!session.boot?.authenticated) return false
  if (meta.module && !hasModule(meta.module)) return false
  if (meta.permission) return can(meta.permission)
  // Routes without a capability are authenticated-only (Dashboard, public forms).
  return true
}

export function visibleNavItems() {
  return NAV_ITEMS.filter(itemAllowed)
}

export function navBySection() {
  const items = visibleNavItems()
  return [
    { key: 'main', label: 'Parish' },
    { key: 'member', label: 'My church' },
    { key: 'admin', label: 'Admin' },
  ]
    .map((s) => ({ ...s, items: items.filter((i) => (i.section || 'main') === s.key) }))
    .filter((s) => s.items.length)
}
